{
  "version": 1,
  "asset_id": "8a4c254c-9767-4f19-b863-9ba985105a2f",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8a4c254c-9767-4f19-b863-9ba985105a2f/hiatal-type-2-v2-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8a4c254c-9767-4f19-b863-9ba985105a2f/hiatal-type-2-v2-1200.webp",
  "original_filename": "hiatal-type-2-v2-1200.webp",
  "size": 97052,
  "content_type": "image/webp",
  "created_at": "2026-09-24T19:25:15Z"
}
